/* eslint-disable max-len */
import React from 'react';
import { IconProps } from '../IconProps';
import { SVGWrapper } from '../SVGWrapper';

const InspectionsNavigationIcon: React.FC<IconProps> = ({ aspect, color, style = {} }) => (
    <SVGWrapper aspect={aspect} color={color} style={style}>
        <path
            stroke="none"
            fill={color}
            d="M9.7,19.5c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9C10.6,19.9,10.2,19.5,9.7,19.5z"
        />
        <path
            d="M18,3.4c0-0.9-0.7-1.6-1.6-1.6H3c-0.9,0-1.6,0.7-1.6,1.6v17.1c0,0.9,0.7,1.6,1.6,1.6h13.3
	c0.9,0,1.6-0.7,1.6-1.6V3.4z M1.4,18.7H18"
        />
        <path
            stroke="none"
            fill={color}
            d="M22.9,4.4l-0.2-0.2c-0.4-0.4-1.1-0.4-1.5,0l-8.4,8.4c-0.1,0.1-0.2,0.3-0.2,0.4l-0.3,1.3c-0.1,0.3,0.2,0.5,0.4,0.5l1.3-0.3
	c0.2,0,0.3-0.1,0.5-0.3l8.4-8.4C23.4,5.5,23.4,4.9,22.9,4.4z"
        />
    </SVGWrapper>
);

export default InspectionsNavigationIcon;
